exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".RightSidebar-4243c17d{display:flex;flex-flow:column;height:100%}.RightSidebar-4243c17d .header-a2ee845c{background-color:#6982FF;color:#FAFAFA;padding:1em;font-size:16px;flex:0 0 auto}.RightSidebar-4243c17d .closeIcon-e231e558{font-size:21px;color:#fff;opacity:0.5;float:right;text-shadow:0 1px 0 #fff;cursor:pointer}.RightSidebar-4243c17d .closeIcon-e231e558:hover{opacity:1}.RightSidebar-4243c17d .scrollContainer-b0fbf8b1{overflow-y:auto;flex:0 1 auto;height:100%}.RightSidebar-4243c17d .topHalf-c99970ae{padding:1em}.RightSidebar-4243c17d .bottomHalf-bcf2317e{border-top:1px solid #E0E0E0;padding:1em}\n", ""]);

// Exports
exports.locals = {
	"RightSidebar": "RightSidebar-4243c17d",
	"header": "header-a2ee845c",
	"closeIcon": "closeIcon-e231e558",
	"scrollContainer": "scrollContainer-b0fbf8b1",
	"topHalf": "topHalf-c99970ae",
	"bottomHalf": "bottomHalf-bcf2317e"
};